import { api } from "./base.api.ts";

export const getNotifications = async (role) => {
	const res = await api.get(`view-notifications/${role}`);
	return res.data;
};

export const readNotification = async (notificationId, status = "read") => {
	const res = await api.post(
		"update-notification-status",
		{
			notification_id: notificationId,
			status,
		},
		{
			withCredentials: false,
		},
	);
	return res.data;
};

export const clearNotifications = async (role) => {
	const res = await api.post(`clear-notifications/${role}`);
	return res.data;
};
